import {Component, Inject, OnInit} from '@angular/core';
import {ProposalService} from "../shared/proposal.service";
import {FormService} from "../shared/form.service";
import {OfferService} from "../shared/offer.service";
import {NX_MODAL_DATA, NxDialogService} from "@aposin/ng-aquila/modal";
import {FormBuilder} from "@angular/forms";
import {Router} from "@angular/router";
import {SharedService} from "../shared/shared.service";
import {BigPropertyService} from "../components/Step 1/details2/big-property.service";
import {catchError, debounceTime, distinctUntilChanged, switchMap} from "rxjs/operators";
import {of} from "rxjs";

@Component({
  selector: 'app-insured-sum-modal',
  templateUrl: './insured-sum-modal.component.html',
  styleUrls: ['./insured-sum-modal.component.scss']
})
export class InsuredSumModalComponent implements OnInit {
  currentForm;
  parentForm;
  movableinsuranceSumRecommended;
  movableinsuranceSum;
  immovableinsuranceSumRecommended;
  isLoading = true;

  constructor(public proposalService: ProposalService,
              public formService: FormService,
              public offerService: OfferService,
              public bigPropertyService: BigPropertyService,
              @Inject(NX_MODAL_DATA) public data: any,
              public dialogService: NxDialogService,
              public formBuilder: FormBuilder,
              public router: Router,
              public sharedService: SharedService) {
    this.parentForm = this.formService.currentForm;
    this.currentForm = this.formBuilder.group({
      immovableinsuranceSumRecommended: [this.parentForm.getRawValue().immovableinsuranceSumRecommended, [this.formService.requiredIfExists()]],
      movableinsuranceSumRecommended: [this.parentForm.getRawValue().movableinsuranceSumRecommended, [this.formService.requiredIfExists()]]
    });
  }

  ngOnInit(): void {
    /*this.bigPropertyService.howBig(this.parentForm.value.area)
      .subscribe(x => {
        this.movableinsuranceSumRecommended = x.immovableinsuranceSum;
        this.immovableinsuranceSumRecommended = x.immovableinsuranceSum;
      });*/

    const fields = ['movableinsuranceSumRecommended', 'immovableinsuranceSumRecommended'];
    this.movableinsuranceSum = this.parentForm.getRawValue().movableinsuranceSum;
    fields.forEach((item, index) => {
      this.currentForm.controls[item].valueChanges
        .pipe(
          debounceTime(300),
          distinctUntilChanged(),
          switchMap(term => {
              this.isLoading = true;
              if (item === 'immovableinsuranceSumRecommended' && term) {
                const {
                  propertyCategory,
                  propertySubcategory,
                  currency,
                  immovableinsuranceSumRecommended
                } = this.parentForm.getRawValue();
                const mData = {
                  propertyCategory: propertyCategory,
                  propertySubcategory: propertySubcategory,
                  currency: currency,
                  immovableinsuranceSum: this.currentForm.value.immovableinsuranceSumRecommended
                }
                return this.bigPropertyService.getInsSumsMovable(mData).pipe(
                  switchMap((s: any) => {
                    this.movableinsuranceSumRecommended = s.immovableinsuranceSum;
                    this.movableinsuranceSum = s.movableinsuranceSum;

                    this.currentForm.patchValue({
                      immovableinsuranceSum: s.immovableinsuranceSum,
                      movableinsuranceSum: s.movableinsuranceSum,
                      movableinsuranceSumRecommended: this.parentForm.controls.movableinsuranceSumRecommended.value === undefined ? s.movableinsuranceSumRecommended : this.parentForm.controls.movableinsuranceSumRecommended.value,
                    });
                    return this.bigPropertyService.calculatePremiums(this.currentForm.value)
                      .pipe(
                        catchError(err => {
                          this.currentForm.controls[item].setErrors({invalid: err.error.sErr_Text});
                          this.parentForm.updateValueAndValidity();
                          return of(null);
                        })
                      );
                  }));
              }
              if (term) {
                return this.bigPropertyService.calculatePremiums(this.currentForm.value)
                  .pipe(
                    catchError(err => {
                      this.currentForm.controls[item].setErrors({invalid: err.error.sErr_Text});
                      this.currentForm.updateValueAndValidity();
                      return of(null);
                    })
                  );
              } else {
                return of(null);
              }
            }
          )
        ).subscribe(x => {
        if (x) {
          this.isLoading = false;
          fields.forEach(f => {
            this.currentForm.controls[f].setErrors(null);
          });
        }
      });
    });
  }

  updateInsSums() {
    const formData = this.currentForm.value;
    this.parentForm.patchValue(formData);
    this.dialogService.closeAll();
  }

}
